<template>
  <div class="volunteer-card-container">
    <v-card
      class="modern-volunteer-card rounded-xl"
      :elevation="isHovered ? 3 : 1"
      @mouseover="isHovered = true"
      @mouseleave="isHovered = false"
      @click="goToProfile"
    >
      <!-- Loading state -->
      <v-skeleton-loader
        v-if="loading || !volunteer"
        type="image, list-item-two-line"
        class="pa-4"
      />
      <!-- Loaded state -->
      <template v-else>
        <!-- Card header with background and avatar -->
        <div class="card-header position-relative">
          <div class="header-bg">
            <img
              v-if="volunteer.bgImage"
              :src="volunteer.bgImage"
              alt="Volunteer Cover Image"
              class="w-100 h-100"
            />
          </div>
          <div class="avatar-container">
            <volunteer-avatar
              :img="volunteer.midThumbnail || volunteer.image"
              :name="volunteer.first_name + volunteer.last_name"
              :size="avatarSize"
              class="elevation-3"
            />
          </div>
        </div>

        <!-- Card content -->
        <div class="mt-2 text-center pa-4">
          <h3 class="mb-1 text-h6 font-weight-bold primary-color text-truncate">
            {{ volunteer.first_name + " " + volunteer.last_name }}
            <v-icon
              v-if="volunteer.profile_share_privacy !== 'Public'"
              small
              color="grey darken-1"
              class="ml-1"
              >mdi-lock</v-icon
            >
          </h3>

          <template v-if="profile?.type === 'Volunteer'">
                        <div class="social-stats mb-4">
              <div class="stat-item">
                <div class="stat-value">{{ (volunteer.followers || []).length }}</div>
                <div class="stat-label">{{ (volunteer.followers || []).length === 1 ? $t("follower") : $t("followers") }}</div>
              </div>
              <div class="stat-divider"></div>
              <div class="stat-item">
                <div class="stat-value">{{ (volunteer.followed_by || []).length }}</div>
                <div class="stat-label">{{ $t("following") }}</div>
              </div>
            </div>

              <!-- Follow/Unfollow Button -->
              <div class="d-flex justify-space-between">
                    <v-btn
                      :color="isFanned ? 'success' : '#3B7CA1'"
                      :outlined="isFanned"
                      :dark="!isFanned"
                      rounded
                      class="mr-2 flex-grow-1"
                      height="36"
                      @click.stop="becameFan"
                      :loading="loading"
                    >
                      <v-icon left size="18">
                        {{ isFanned ? "mdi-check" : "mdi-plus" }}
                      </v-icon>
                      {{ isFanned ? $t("Following") : $t("Follow") }}
                    </v-btn>
              </div>
            </template>


        </div>
      </template>
    </v-card>

    <!-- Private profile dialog -->
    <volunteer-private-dialog-vue v-model="dialog" />
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import VolunteerAvatar from "../VolunteerAvatar.vue";
import VolunteerPrivateDialogVue from "./VolunteerPrivateDialog.vue";

export default {
  name: "ModernVolunteerCard",
  components: {
    VolunteerAvatar,
    VolunteerPrivateDialogVue
  },
  props: {
    volunteer: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      loading: false,
      dialog: false,
      isHovered: false
    };
  },
  computed: {
    ...mapState("auth", {
      profile: "profile",
      type: "type"
    }),
    ...mapState("volunteer", {
      followingVolunteers: "followingVolunteers"
    }),
    // getFanned() {
    //   if (!this.profile.followers) return false;
    //   return this.profile.followers.includes(this.volunteer._id);
    // },
    getFanned() {
      if (!this.profile.followed_by) return false;
      return this.profile.followed_by.includes(this.volunteer._id);
    },
    isFanned() {
      // Always reflect the current state of profile.followed_by
      return Array.isArray(this.profile?.followed_by) && this.profile.followed_by.includes(this.volunteer._id);
    },
    avatarSize() {
      const bp = this.$vuetify.breakpoint;
      if (bp.xs) return 50;
      if (bp.sm) return 60;
      return 70;
    }
  },
  methods: {
    ...mapActions("volunteer", {
      followVolunteer: "followVolunteer"
    }),
    goToProfile() {
      if (this.volunteer.profile_share_privacy !== "Public") {
        this.dialog = true;
      } else {
        this.$router.push({
          name: "volunteer-profile-details",
          params: { id: this.volunteer._id }
        });
      }
    },
//       async becameFan() {
//         this.loading = true;
//         const wasFollowing = this.getFanned;

//         try {
//           await this.followVolunteer({
//             followed: !wasFollowing,
//             user: this.volunteer._id
//           });

//           const myId = this.profile._id;
//           const theirId = this.volunteer._id;
//  // Update local state immediately
//           if (wasFollowing) {
//             // Unfollow logic
//             this.volunteer.followers = this.volunteer.followers.filter(id => id !== myId);
//             this.profile.followed_by = this.profile.followed_by.filter(id => id !== theirId);
//           } else {
//             // Follow logic
//             this.volunteer.followers = [...this.volunteer.followers, myId];
//             // this.profile.followed_by = [...this.profile.followed_by, theirId];
//           }

//           // Update Vuex store (if tracking globally)
//           const updatedFollowing = wasFollowing
//             ? this.followingVolunteers.filter(id => id !== theirId)
//             : [...this.followingVolunteers, theirId];
//             // console.log(updatedFollowing, 'updatedFollowing');
//           this.$store.commit("volunteer/setFollowingVoulnteers", updatedFollowing);

//         } catch (error) {
//           this.$store.dispatch("notification/show", {
//             text: error.response?.data?.message || "An error occurred",
//             color: "error"
//           });
//         } finally {
//           this.loading = false;
//         }
//       }
 async becameFan() {
      this.loading = true;
      const wasFollowing = this.isFanned;
      try {
        await this.followVolunteer({
          followed: !wasFollowing,
          user: this.volunteer._id
        });

        // The store now handles updating both:
        // 1. The current user's profile (including followed_by and followers)
        // 2. The volunteer's followers array for immediate UI feedback
        // No need for manual updates to avoid conflicts

      } catch (error) {
        this.$store.dispatch("notification/show", {
          text: error.response?.data?.message || "An error occurred",
          color: "error"
        });
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped>
.volunteer-card-container {
  width: 100%;
  max-width: 300px;
  margin: auto;
  padding: 0 8px;
}

.modern-volunteer-card {
  transition: all 0.3s ease;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  height: 100%;
}

.card-header {
  height: 100px;
  width: 100%;
  position: relative;
}

.header-bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, #0a5b8a 0%, #0a7b8a 100%);
}

.avatar-container {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, 0%);
  z-index: 2;
  border-radius: 50%;
}

.text-truncate {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
}

/* Responsive Typography and Layout Adjustments */
@media (max-width: 1024px) {
  .modern-volunteer-card {
    padding: 12px;
  }

  .card-header {
    height: 90px;
  }
}

@media (max-width: 768px) {
  .volunteer-card-container {
    max-width: 90%;
  }

  .card-header {
    height: 80px;
  }
}

@media (max-width: 600px) {
  .volunteer-card-container {
    max-width: 100%;
    padding: 0 12px;
  }

  .card-header {
    height: 70px;
  }

  .avatar-container {
    top: 35px;
  }

  h3.text-h6 {
    font-size: 1rem;
  }

  .v-btn {
    font-size: 0.85rem;
  }
}
.v-btn {
  font-size: 13px;
}

.volunteer-cards-wrapper {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 16px; /* space between cards */
  margin: 0 auto;
  padding: 16px;
}

.volunteer-card-container {
  flex: 1 1 calc(50% - 16px); /* 2 cards per row with gap */
  max-width: 300px;
}

/* On small screens, force single column */
@media (max-width: 768px) {
  .volunteer-card-container {
    flex: 1 1 100%;
    max-width: 100%;
  }
}

/* Modern social stats */
.social-stats {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
  margin: 16px 0;
}
  .stat-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0 12px;
  }
    .stat-value {
      font-size: 1.2rem;
      font-weight: 700;
      color: #333;
      line-height: 1.2;
    }
    
    .stat-label {
      font-size: 0.75rem;
      color: #666;
      text-transform: uppercase;
      letter-spacing: 0.5px;
      margin-top: 2px;
    }
  
  
  .stat-divider {
    width: 1px;
    height: 24px;
    background: rgba(0, 0, 0, 0.1);
  }

@media (max-width: 768px) {
  .volunteer-card-container {
    max-width: 90%;
  }
  .card-header {
    height: 80px;
  }
  .social-stats {
    gap: 8px;
  }
    .stat-item {
      padding: 0 8px;
    }
}

</style>
